import { InjectionToken } from '@angular/core';

export const FAKTURNIA_APP_CONFIG = new InjectionToken<any>('FAKTURNIA_APP_CONFIG');
